module.exports = __webpack_public_path__ + "static/media/Leave4.9c5d1ff6.svg";